import { ESuggestType } from '../types';
export function isBuildingSuggest(suggestion) {
  return [ESuggestType.newbuilding, ESuggestType.businessCenter, ESuggestType.shoppingCenter, ESuggestType.village, ESuggestType.coworking].includes(suggestion.type);
}
export function ensureBuildingSuggestion(suggestion) {
  return suggestion;
}